import React from 'react'
import { Helmet } from 'react-helmet'
import Menu from '../component/Menu'
import HeaderCasestudy from '../component/HeaderCasestudy'
import Casestudybody8 from '../component/Casestudybody8'
import FooterNew from '../component/FooterNew';
import thumbimg from '../images/case-study-client8.webp'
    

const CaseStudy8 = ({setBlank}) => {

  const headings = "<h2 style='display:inline-block'>Strategic Consulting</h2><h4>for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia</h4>";

  return (
    <>
        <Helmet>
          <title>Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia</title>
          <meta property="og:image" content={thumbimg} /> 
          <meta property="og:title" content="Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia" />
          <meta property="og:description" content="Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia"/>
        </Helmet>

        <Menu setBlank={setBlank} />
        <HeaderCasestudy headings={headings} />  
        <Casestudybody8 />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy8
